/* eslint-disable consistent-return */

import Vue from 'vue';
import VueRouter from 'vue-router';

import { setLang } from '@/utils/store';
import Home from '../views/Home.vue';
import Services from '../views/Services.vue';
import Team from '../views/Team.vue';
import Contact from '../views/Contact.vue';

const locale = `${window.location.pathname.split('/').slice(0, 2).join('/')}/`;
const description = locale === '/it/' ? 'Centro media indipendente che applica il dato tramite approcci avanzati e creativi. Gestiamo investimenti nella comunicazione Tv, Web, Stampa e molto di più.' : 'Independent and Neutral Media Center that masters data with advanced, creative approaches. Data management hub handling investments in TV, web, print and more.';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/it/',
  },
  {
    path: '*',
    redirect: '/it/',
  },
  {
    path: '/en/',
    component: Home,
    meta: {
      title: 'Adtelier | Being',
    },
  },
  {
    path: '/it/',
    component: Home,
    meta: {
      title: 'Adtelier | Essere',
    },
  },
  {
    path: '/en/services',
    component: Services,
    meta: {
      title: 'Adtelier | Elevate',
    },
  },
  {
    path: '/it/services',
    component: Services,
    meta: {
      title: 'Adtelier | Elevare',
    },
  },
  {
    path: '/en/team',
    component: Team,
    meta: {
      title: 'Adtelier | Unite',
    },
  },
  {
    path: '/it/team',
    component: Team,
    meta: {
      title: 'Adtelier | Unire',
    },
  },
  {
    path: '/en/contact',
    component: Contact,
    meta: {
      title: 'Adtelier | Contact',
    },
  },
  {
    path: '/it/contatti',
    component: Contact,
    meta: {
      title: 'Adtelier | Contati',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: '',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes,
});

// before each
router.beforeEach((to, _from, next) => {
  setLang();

  const nearestWithTitle = to.matched.slice().reverse().find((r) => r.meta && r.meta.title);
  const nearestWithMeta = to.matched.slice().reverse().find((r) => r.meta && r.meta.metaTags);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map((el) => el.parentNode.removeChild(el));

  if (!nearestWithMeta) {
    document.querySelector('meta[name="description"]').setAttribute('content', description);
    document.querySelector('meta[property="og:description"]').setAttribute('content', description);
    document.querySelector('meta[name="twitter:description"]').setAttribute('content', description);
    window.ga('send', 'pageview');
    return next();
  }
});

export default router;
